import { Fetch } from 'lib/Fetch';

export function companyWarranty({ idWarranty }) {
  return new Fetch('api_2')
    .url(`/external/global/warranty-companies/${idWarranty}`)
    .method('get')
    .userToken()
    .send();
}
